export const Constants = {
	PER_PAGE: 20,
	PLAN_FOR: {
		SCHOOL: 1,
		TEACHER: 2
	},
	PLAN_TYPES: {
		MONTHLY: 1,
		YEARLY: 2,
	},
	USER: {
		LEVELS: {
			ADMIN: 1,
			MODERATOR: 2,
			PROFESSOR: 3,
			SCHOOL: 4,
			PARENT: 5,
		},
		STATUS: {
			PENDING: 0,
			ACTIVE: 1,
			INACTIVE: 2,
		},
		VERIFIED: {
			PENDING: 0,
			APPROVED: 1,
			REJECTED: 2,
		}
	},
	ATTENDENCE_STATUS: {
		ABSENT: 0,
		PRESENT: 1,
	},
	APPROVED_STATUS: {
		FAILED: 0,
		APPROVED: 1,
	},
	BASENAME: process.env.REACT_APP_BASE,
	COUNTRIES: {
		VEN: 1,
		COL: 2,
	},
	CURRENCY_SYMBOLS: {
		VEN: 'Bs',
		COL: '$',
		USA: '$',
	},
	STUDENT: {
		STATUS: {
			ACTIVE: 1,		// Activo
			INACTIVE: 0, 	// Suspendido
			REMOVED: 2,		// Retirado
		},
	},
	SUBJECTS: {
		TYPE_QUALIFICATION: {
			QUANTITATIVE: 1,
			QUALITATIVE: 2,
		}
	},
	PAYMENT_METHODS: {
		VE_PAYPAL: 1,
    CO_PAYPAL: 2,
    VE_MOBILE: 3,
    CO_MOBILE: 4,
    FREE: 5,
	},
	LOCAL_PAYMENT_METHODS: {
		VE_MOBILE: 3,
		CO_MOBILE: 4,
	},
	PAYMENT_STATUS: {
		PENDING: 0,
		APPROVED: 1,
		REJECTED: 2,
	},
	PAYMENT_TYPE: {
		ACQUIRE: 1,
		RENEW: 2,
	},
	PLAN_DURATION: {
		FREE: {
			AMOUNT: 30,
			UNIT: 'days',
		},
		PAID: {
			AMOUNT: 1,
			UNIT: 'months',
		},
	},
	TYPES_EDUCATION: {
		INITIAL: 1,
		PRIMARY: 2,
		MEDIA_GENERAL: 3,
	},
}